import React from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Dialog } from '@modernloop/shared/components';
import { Typography } from '@mui/material';

type Props = {
  onClose: () => void;
};

const SelfScheduleRequestedAlert = ({ onClose }: Props) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open
      maxWidth="xs"
      onClose={onClose}
      title={t('hiring-dashboard-schedule:schedule.dialog.availabilityRequestPending')}
    >
      <Typography fontWeight={400}>{t('hiring-dashboard-schedule:schedule.selfSchedule.requestAlreadyOut')}</Typography>
    </Dialog>
  );
};

export default SelfScheduleRequestedAlert;
